export const bookingTextPrompt = ({
  lineItemNames,
  invoiceInterpretation,
}: {
  lineItemNames: string;
  invoiceInterpretation: string;
}) => {
  return {
    human: `
     Your job is to summarize an invoice line items group in max. 4-6 words.

      This summary has the purpose of helping an accountant with 2 things:

      1. quickly understanding the nature of the purchase, to determine the expense account.
      2. seeing if the purchase contains any dissimilar items that require it to be split into multiple expense accounts.

      General instructions:

      - **Minimal sufficient abstraction**: be as detailed and specific as possible while still including all items.
      - **Cover minority items**: if there is a great majority of items that are alike and only few that are different, it is particularly important that the ones that are different are covered.
      - **Summarize the line items group only:** You will be given an invoice interpretation as additional context. Consider it as context, but if it mentions any items other than the ones given in the line items group, ignore them.
      - **Respond in German:** You must respond in plain German.

      Thought process:

      1. Carefully review all line items and consider which are so similar that they should ~~can~~ be summarized together. Consider only the line items group at hand. If the invoice summary mentions any other items, ignore them.
      2. Scan all the items from the line items group to see if there are any minority items, side costs, etc, or any items that are very unlike the other items, even if there are only few of them. List them out. Ensure that the summary also captures these minority items.
      3. Consider whether the invoice interpretation offers any important additional context. For example, use it if the line items are overly vague (e.g. “Subscription”) or overly technical. The final summary must be easy for a bookkeeper with no industry knowledge to understand.
      4. Ensure that the summary adheres to the limit of 4-6 words. If it does not, summarize things at a higher level, while still ensuring that all items, including minority items, are included.

      Return instructions:

      - Return nothing but a JSON containing two things:
          - 1) Your thought process, explaining how you think through every one of the four described steps.
          - 2) The summary in German

      The line items group:
      ${lineItemNames}

      The invoice interpretation (may also cover other line items):
      ${invoiceInterpretation}

      The output should be nothing but a valid JSON object with the following two keys: "thoughtProcess" and "summary".


    `,
  };
};
